import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Modal, Menu } from "antd";
import { useIntl } from "react-intl";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { reload, loadPage, reset } from "./ClientsSlice";
import Phone from "../../components/tables/Phone";
import Address from "../../components/tables/Address";
import ClientCategory from "../../components/tables/ClientCategory";
import LinkComponent from "../../components/tables/Link";
import ActionsTable from "../../components/templates/ActionsTable";
import Surface from "../../components/layouts/Surface";
import NewClientWizard from "./newClient/NewClientWizard";
import PrivateClientWizard from "./newClient/PrivateClientWizard";
import { ReactComponent as ClientsImg } from "../../assets/no-clients.svg";
import { isClientActive } from "../../features/clientDetails/clientDetailsSlice";

const ClientsList = () => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [showInactive, setShowInactive] = useState(false);
  const { page: clientsPage, queryParams } = useSelector(
    (state) => state.clients
  );
  const { current, pageSize, total, order, items, filter } = clientsPage;
  const loading = useSelector(
    (state) => state.pendingActions["clients/loadPage"]
  );
  const intl = useIntl();
  let history = useHistory();
  let location = useLocation();
  let { branchId } = useParams();

  const onTextChange = (e) => {
    dispatch(
      loadPage(
        { current: 1, filter: { ...filter, freeText: e.target.value } },
        { ...queryParams }
      )
    );
  };

  const onCheckboxChange = (e) => {
    setShowInactive(e.target.checked);
    dispatch(
      loadPage(
        {
          current: 1,
          filter: { ...filter, freeText: e.target.value },
        },
        { ...queryParams, include_not_active: e.target.checked }
      )
    );
  };

  const onAddClick = () => {
    const url = location.pathname + "/add";
    if (branchId) {
      history.push(url);
    }
    setVisible(true);
  };

  const hide = () => {
    setVisible(false);
  };

  const handleMenuClick = (e) => {
    setVisible(true);
  };

  const dropDownMenuItems = [
    {
      label: intl.formatMessage({
        id: "app.clients.createBranchClient",
      }),
      key: "1",
    },
  ];

  const dropDownMenu = {
    items: dropDownMenuItems,
    onClick: (e) => handleMenuClick(e),
  };

  return (
    <Surface>
      <ActionsTable
        checkActive={(rec) => isClientActive(rec, +branchId)}
        tableItems={[
          {
            title: "name",
            sortIndex: "name",
            sorter: true,
            render: LinkComponent,
            columnProps: {
              pathTarget: "client",
            },
          },
          {
            title: "category.name",
            render: ClientCategory,
          },
          {
            title: "accounting_code",
            responsive: ["lg"],
          },

          {
            title: "specific_data.comittee_name",
            responsive: ["xl"],
          },
          {
            title: "specific_data.comittee_number",
            responsive: ["xxl"],
            width: "160px",
          },
          {
            title: "specific_data.organization_branch_name",
            responsive: ["xl"],
          },
          {
            title: "specific_data.organization_branch_number",
            responsive: ["xxl"],
            width: "160px",
          },
          {
            title: "phone_number",
            responsive: ["md"],
            width: 150,
            render: Phone,
          },
          {
            title: "fax_number",
            responsive: ["xxl"],
            width: 150,
            render: Phone,
          },
          {
            title: "branch_address",
            responsive: ["xxl"],
            render: Address,
            ellipsis: true,
          },
        ]}
        ltrItems={["phone_number"]}
        category={"clients"}
        resource="clients"
        current={current}
        pageSize={pageSize}
        total={total}
        loading={loading}
        textFilter={filter.freeText}
        reload={reload}
        loadPage={loadPage}
        resetPage={reset}
        items={items}
        order={order}
        onTextChange={onTextChange}
        onAddClick={onAddClick}
        onCheckboxChange={onCheckboxChange}
        checkBoxLabel={intl.formatMessage({
          id: "app.employees.showInactive",
        })}
        showInactive={showInactive}
        dropDownMenu={branchId ? dropDownMenu : null}
        addbuttonText={
          branchId ? (
            <FormattedMessage id="app.clients.addClientFromList" />
          ) : (
            <FormattedMessage id="app.clients.addNewClient" />
          )
        }
        headerInputPlaceholder={intl.formatMessage({
          id: "app.clients.typeClientName",
        })}
        showheader={true}
        emptyImage={<ClientsImg />}
        emptytext={<FormattedMessage id="app.tables.noClients" />}
        autoFocus={true}
      />
      <Modal
        closable={false}
        maskClosable={false}
        footer={null}
        width={"900px"}
        styles={{
          body: {
            padding: 0,
          },
        }}
        title={null}
        open={visible}
        onCancel={hide}
        destroyOnClose={true}
      >
        {branchId ? (
          <PrivateClientWizard hideWizard={hide} />
        ) : (
          <NewClientWizard hideWizard={hide} />
        )}
      </Modal>
    </Surface>
  );
};

export default ClientsList;
